<div class="device-indicators-container">
  @for (device of devices; track device.deviceLineCode) {
    <div class="device-indicator" [title]="device.name">
      <div class="device-icon-wrapper">
        <dk-dynamic-icon [svg_path]="device.iconURL"></dk-dynamic-icon>
        @if (device.count > 0) {
          <span class="device-count-badge">{{ device.count }}</span>
        }
      </div>
    </div>
  }
</div>
